<template>
    <div id="app">
        <router-view/>
        <notifications group="foo" />  
    </div>
</template>
<script>
    import '../static/common/js/jquery.slimscroll.min.js'
    import '../static/common/js/bootstrap.min.js'
    import '../static/common/js/slick.js'
    import '../static/prism_admin/js/jquery.overlayScrollbars.min.js'
    import '../static/prism_admin/js/vue-multiselect.min.js'
    import * as types from './types'
	export default {
		name: 'app',
		created() {
            
        },
       
    }
</script>
<style>
    @Import '../static/common/css/bootstrap.min.css';
    @Import '../static/common/css/font-awesome.min.css';
    @Import '../static/prism_admin/css/OverlayScrollbars.min.css';
    @Import '../static/prism_admin/css/style.css';
    @Import '../static/prism_admin/css/vue-multiselect.min.css';
    @Import '../node_modules/froala-editor/css/froala_editor.pkgd.min.css';
</style>



// WEBPACK FOOTER //
// src/App.vue